
export const API_KEY="AIzaSyBTTs6-KHcd-F_rHkv1XrkZljLjvmMD3zw";
export default API_KEY;